module.exports = __webpack_public_path__ + "img/Airbnb-Time-Management-Tame-To-do-list.0bd25ab7.jpg";